<mat-slider color="accent" [disableRipple]="true" style="display: block; margin-left: 0; margin-right: 0;" class="player-slider">
  <input class="zwi-player-slider-thumb" matSliderThumb [value]="percent()" (dragEnd)="emitDragEnd($event)"/>
</mat-slider>
<!--@if (sermon()) {-->
<!--  <mat-slider color="accent" disableRipple="true" style="display: block; margin-left: 0; margin-right: 0;">-->
<!--    <input matSliderThumb [value]="percent()" (dragEnd)="emitDragEnd($event)"/>-->
<!--  </mat-slider>-->
<!--}-->
